// Typelizer digest 6d3ed9fefaca6960c472addf5dca9243
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /rails/active_storage/disk/:encoded_key/*filename */
  show: (
    params: { encodedKey: string | number; filename: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/rails/active_storage/disk/:encoded_key/*filename', params, options),
    method: 'get',
  }),

  /** PUT /rails/active_storage/disk/:encoded_token */
  update: (
    params: { encodedToken: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'put'> => ({
    url: buildUrl('/rails/active_storage/disk/:encoded_token', params, options),
    method: 'put',
  }),
}
